// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const OrderApproval: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 58"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M37 8.3h-6.4v-.6c0-.7-.6-1.3-1.3-1.3h-1.7C27 3.1 24.1.6 20.6.6s-6.4 2.5-7 5.8h-1.7c-.7 0-1.3.6-1.3 1.3v.6H4C2.2 8.3.7 9.8.7 11.6v42.7c0 1.8 1.5 3.3 3.3 3.3h33c1.8 0 3.3-1.5 3.3-3.3V11.5c0-1.8-1.5-3.2-3.3-3.2zM20.5 3.2c2 0 3.7 1.3 4.3 3.2h-8.5c.5-1.9 2.2-3.2 4.2-3.2zM13.1 9h14.8v1.2H13.1V9zm24.5 45.2c0 .3-.3.6-.6.6H4c-.3 0-.6-.3-.6-.6V11.5c0-.3.3-.6.6-.6h6.4v.6c0 .7.6 1.3 1.3 1.3h17.5c.7 0 1.3-.6 1.3-1.3v-.6H37c.3 0 .6.3.6.6v42.7z"/><path d="M27.3 23.9L18 37.6l-4.4-4.4c-.5-.5-1.4-.5-1.9 0s-.5 1.4 0 1.9l5.5 5.5c.3.3.6.4.9.4h.1c.4 0 .8-.2 1-.6l10.2-15.1c.4-.6.3-1.4-.4-1.9-.5-.3-1.3-.1-1.7.5z"/></svg>;
};

export default React.memo(OrderApproval);
